import React from 'react';
import './ButtonScroll.css';
import PropTypes from 'prop-types';
import ButtonSquare from './BasicButton';
import scrollIcon from './assets/img/scroll_button_icon.png';

const buttonStyle = {
  background: `url(${scrollIcon}) no-repeat center`,
  width: '75px',
  height: '75px',
};

const ButtonScroll = (props) => {
  const { link } = props;
  return (
    <ButtonSquare link={link}>
      <a href={link}>
        <div style={buttonStyle} className="animate-scroll" />
      </a>
    </ButtonSquare>
  );
};


ButtonScroll.defaultProps = {
  link: '#',
};

ButtonScroll.propTypes = {
  link: PropTypes.string,
};

export default ButtonScroll;



// WEBPACK FOOTER //
// ./src/components/ButtonSquare/ButtonScroll.jsx